import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: true
};

const statusPageSlices = createSlice({
    name: "STATUSPAGE",
    initialState,
    reducers: {
        disableStatusPageSlice: (state) => {  
            state.status = false;
        },
        enableStatusPageSlice: (state) => { 
            state.status = true;
        }
    }
}) 
export const { disableStatusPageSlice,enableStatusPageSlice } = statusPageSlices.actions;
export const selectStatusPageSlice  =  (state)  => state.statusPageSlices.status;
export default statusPageSlices.reducer;
